import {SOPostConstraint} from '../../core/constraint/so-post-constraint';
import {ConstraintCore} from './constraint.core';
import {SOGetConstraint} from '../../core/constraint/so-get-constraint';
import {FormField, SelectionOption} from 'lionheartland';
import {postConstraintFormFieldOptions} from './post-constraint-form-fields';
import {AdapterProtocol} from 'lionheartland';
import {BasePost} from 'lionheartland';

export class RAPostConstraint extends BasePost implements AdapterProtocol {
  formFieldOptions = Object.values(postConstraintFormFieldOptions);

  RequestClass = SOPostConstraint

  constructor(
    public entityCore: ConstraintCore
  ) {
    super();
  }

  onSet() {
    super.onSet()
  }

  prepareRequest() {
    this.request = new this.RequestClass(
      this.getFormValueFromIdentifier('name'),
      this.getFormValueFromIdentifier('identifier'),
      this.getFormValueFromIdentifier('description'),
    )
  }


  onSelectionChange(field: FormField) {
    super.onSelectionChange(field)
  }

  fetchOptions(field: FormField) {
    super.fetchOptions(field)
  }

  getSelectionOption(field: FormField, entity): SelectionOption {
    return super.getSelectionOption(field, entity)
  }
}